import { formatMoney } from 'accounting'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useAgencyOrderBundle, { useRelations } from '@hooks/useAgencyOrderBundle'

import { AgencyOrderBundleModel } from '@models/types'

interface OrderBundleListItemProps {
  agencyOrderBundle: AgencyOrderBundleModel,
}
const OrderBundleListItem = (props: OrderBundleListItemProps) => {
  const { agencyOrderBundle } = props

  const agencyOrderBundlePaylod = useAgencyOrderBundle(agencyOrderBundle)
  const {
    callbacks: { manageAgencyOrderBundle },
  } = agencyOrderBundlePaylod

  const { orderBundle: { price, title } } = useRelations(agencyOrderBundle)

  return (
    <DashboardModuleListItem onClick={() => manageAgencyOrderBundle()} title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {formatMoney(price)}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default OrderBundleListItem
